/**
 * Helpers for the event form's physical-location address fields.
 *
 * Selecting an organization auto-fills these from the org's physical address
 * (R2A). The "Clear" button (#13, 2026-06) lets the operator wipe the auto-filled
 * address so they can type their own. Pure function so the clear behavior is
 * unit-tested directly and the form just applies the result.
 */

export interface EventLocationAddressFields {
  location_address_line1?: string;
  location_city?: string;
  location_state?: string;
  location_postal_code?: string;
}

/** True when any physical-address field has a value worth offering to clear. */
export function hasLocationAddress(
  fields: EventLocationAddressFields,
): boolean {
  return Boolean(
    (fields.location_address_line1 || "").trim() ||
      (fields.location_city || "").trim() ||
      (fields.location_state || "").trim() ||
      (fields.location_postal_code || "").trim(),
  );
}

/**
 * Return a copy of the form state with the four physical-address fields emptied.
 * Everything else is preserved untouched.
 */
export function clearLocationAddress<T extends EventLocationAddressFields>(
  fields: T,
): T {
  return {
    ...fields,
    location_address_line1: "",
    location_city: "",
    location_state: "",
    location_postal_code: "",
  };
}
